import React from "react";

const CustomError = ({ errorMessage }) => {
  return errorMessage ? <div className="error">{errorMessage}</div> : <></>;
};

export default CustomError;
